var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBagLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_327_5702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_327_5702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.346 62.8788H100.253V59.229C100.253 48.6303 91.6303 40 81.0236 40C70.417 40 61.7946 48.6224 61.7946 59.229V62.8788H46.7015C45.2113 62.8788 44 64.09 44 65.5802V105.505C44 113.497 50.5026 120 58.4955 120H103.544C111.537 120 118.039 113.497 118.039 105.505V65.5802C118.039 64.09 116.828 62.8788 115.338 62.8788H115.346ZM64.4961 77.183C65.9863 77.183 67.1975 75.9717 67.1975 74.4815V68.2817H94.8417V74.4815C94.8417 75.9717 96.053 77.183 97.5432 77.183C99.0334 77.183 100.245 75.9717 100.245 74.4815V68.2817H112.636V105.505C112.636 110.517 108.556 114.597 103.544 114.597H58.4955C53.483 114.597 49.4029 110.517 49.4029 105.505V68.2817H61.7946V74.4815C61.7946 75.9717 63.0059 77.183 64.4961 77.183ZM67.1975 62.8788V59.229C67.1975 51.6027 73.3974 45.4029 81.0236 45.4029C88.6499 45.4029 94.8497 51.6027 94.8497 59.229V62.8788H67.2055H67.1975Z",
    fill: "#BDBDBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBagLarge);
export default __webpack_public_path__ + "static/media/icon_bag_large.9a685de6ea92e48853bfb1d298344922.svg";
export { ForwardRef as ReactComponent };